export const TOKEN_TYPE = {
    TOKEN: 1,
    REFRESH_TOKEN: 2
};

export const CONTENT_TYPE = {
    JSON: "application/json",
    MERGE_PATCH_JSON: "application/merge-patch+json",
    LD_JSON: "application/ld+json"
};

export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_MANAGER = "ROLE_MANAGER";
export const ROLE_WORKER = "ROLE_WORKER";
export const ROLE_DOCTOR = "ROLE_DOCTOR";

export const WORKER_TYPE_SPECIALIST = "specijalista";
export const WORKER_TYPE_PSIHOLOG = "psiholog";
export const WORKER_TYPE_DEFEKTOLOG = "defektolog";

export const USER_ROLES = [
    { value: ROLE_ADMIN, label: "Administrator" },
    { value: ROLE_MANAGER, label: "Menadžer" },
    { value: ROLE_WORKER, label: "Radnik" },
    { value: ROLE_DOCTOR, label: "Doktor" }
];

export const WORKER_TYPES = [
    { value: WORKER_TYPE_SPECIALIST, label: WORKER_TYPE_SPECIALIST.charAt(0).toUpperCase() + WORKER_TYPE_SPECIALIST.slice(1) },
    { value: WORKER_TYPE_PSIHOLOG, label: WORKER_TYPE_PSIHOLOG.charAt(0).toUpperCase() + WORKER_TYPE_PSIHOLOG.slice(1) },
    { value: WORKER_TYPE_DEFEKTOLOG, label: WORKER_TYPE_DEFEKTOLOG.charAt(0).toUpperCase() + WORKER_TYPE_DEFEKTOLOG.slice(1) }
];

export const EXPENSE_TAB = 0;
export const EXPENSE_TYPE_TAB = 1;

export const ARTICLE_TAB = 0;
export const PERCENTAGE_TAB = 1;

export const DATE_FORMAT = "M/d/yyyy";
